import Common from "../../componets/Common";

export const generarFormPagoVisa = (sessionKey, idComercio, invoice, total) => {
  const scriptEl = document.createElement("script");

  scriptEl.setAttribute("src", Common.urlFormulario);
  scriptEl.setAttribute(
    "data-sessiontoken",
    sessionKey
  );
  scriptEl.setAttribute("data-merchantid", idComercio);
  scriptEl.setAttribute(
    "data-merchantlogo",
    "https://www.laureate.net/wp-content/uploads/2019/03/UPN.png"
  );
  scriptEl.setAttribute(
    "data-merchantname",
    "Universidad Privada del Norte"
  );
  scriptEl.setAttribute("data-purchasenumber", invoice);
  scriptEl.setAttribute("data-channel", "web");
  scriptEl.setAttribute("data-amount", total);
  scriptEl.setAttribute("dataexpirationminutes", 3);
  scriptEl.setAttribute("data-cardholderlastname", "");
  scriptEl.setAttribute("data-cardholderemail", "");
  scriptEl.setAttribute(
    "data-timeouturl",
    "http://localhost/errortiemout"
  );

  return scriptEl;
}
